import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import { siteLinks } from '../data/siteData'

import ClientOnly from '../helper/ClientOnly'
import GSearch from './GSearch'

import DropdownLink from './DropdownLink'
import FavIcon from '../images/favicon.png'


const Header = () => {

	const [isNavOpen, setIsNavOpen] = useState(false)

	useEffect(() => {

		const handleDocClick = e => {
			if (!e.target.closest('.topNav')) {
				setIsNavOpen(false)
			}
		}

		if (isNavOpen) {
			window.document.addEventListener('click', handleDocClick)
		} else {
			window.document.removeEventListener('click', handleDocClick)
		}

		return () => {
			window.document.removeEventListener('click', handleDocClick)
		}
	}, [isNavOpen, setIsNavOpen])

	return (
		<>
			<div className="topNav">
				<div className="topBrand df jcc aic">
					<div className="baseWrap df aic fww jcsb">
						<div className="brand df aic">
							<img
								className="brand_img"
								src={FavIcon}
								sizes="60x60"
								alt="NAC Dharamgarh"
							/>
							<div className="">
								<h2 className="title">Notified Area Council</h2>
								<span className="sub">Dharamgarh, Kalahandi</span>
							</div>
						</div>
						<div className="accessibility">
							<div className="df aic">
								<button className="btn btn-acc sm" id="fz_sm" title="Decrease font size">A-</button>
								<button className="btn btn-acc" id="fz" title="Standard font size">A</button>
								<button className="btn btn-acc lg" id="fz_lg" title="Increase font size">A+</button>
						&nbsp;&#124;&nbsp;
						<a href="#!" className="link">Download Screen Reader</a>
							</div>
							<div className="search">
								<ClientOnly>
									<GSearch />
								</ClientOnly>
								{/* <div className="searchWrap df">
										<input type="search" name="q" id="site-search" placeholder="Type here to Search ..."
											autoComplete="off" spellCheck="false" />
										<input type="hidden" id="cx" name="cx" value="b3dd1bb08deace843" />
										<button type="submit" name="submit" className="noDefault submit df aic">
											<i className="material-icons-round">search</i>
										</button>
									</div> */}
							</div>
						</div>
						<div className="navTrigger" id="navTrigger" role="button" tabIndex={0} onKeyDown={() => { }} onClick={() => {
							isNavOpen ? setIsNavOpen(false) : setIsNavOpen(true)
						}}>
							<i className="material-icons-round">menu</i>
						</div>
					</div>
				</div>
				{/* Navigation */}
				<nav className={`nav ${isNavOpen ? 'active' : ''}`}>
					<ul className="navList df fww baseWrap">
						<li className="navItem" key={-1} data-key={-1}><Link to="/" className="navLink" activeClassName="active">
							<i className="material-icons-round">house</i>
						</Link></li>
						{siteLinks.map((l, idx) => {
							return typeof l.link === 'string' ? (
								<li className="navItem" key={idx} data-key={idx}>
									{l.ext ? (
										<a href={l.link} className="navLink"><span>{l.title}</span></a>
									) : (
											<Link to={l.link} activeClassName="active" className="navLink"><span>{l.title}</span></Link>
										)
									}
								</li>
							) : (
									<DropdownLink anchor={l.title} links={l.link} key={idx} />
								)
						}
						)}
						{/* <li className="navItem dropdown">
							<a href="#!" className="navLink dropdown-anchor">
								<span>About</span>
							</a>
							<ul className="dropdown-list">
								<li className="dropdown-item">
									<a href="#!">Organization</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Profile</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Structure</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Standing Committee</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Officer's Profile</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Zones and Wards</a>
								</li>
							</ul>
						</li>
						<li className="navItem dropdown">
							<a href="#!" className="navLink dropdown-anchor">
								<span>Services</span>
							</a>
							<ul className="dropdown-list">
								<li className="dropdown-item">
									<a href="#!">e-Services</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Public Health Services</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Water Suply Services</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Street Lighting</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Parks and Recreation</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Plantation Services</a>
								</li>
							</ul>
						</li>
						<li className="navItem dropdown">
							<a href="#!" className="navLink dropdown-anchor">
								<span>Programs</span>
							</a>
							<ul className="dropdown-list">
								<li className="dropdown-item">
									<a href="#!">Prayas</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Rajiv Awaz Yojana</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Urban Poverty Alleviation</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Go Green Drive</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">NUHM</a>
								</li>
							</ul>
						</li>
						<li className="navItem dropdown">
							<a href="#!" className="navLink dropdown-anchor">
								<span>Departments</span>
							</a>
							<ul className="dropdown-list">
								<li className="dropdown-item">
									<a href="#!">PR & Communication</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Disaster Management</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Finance</a>
								</li>
								<li className="dropdown-item">
									<a href="#!">Health and Sanitation</a>
								</li>
							</ul>
						</li>
						<li className="navItem">
							<a href="#!" className="navLink"><span>Budget</span></a>
						</li>
						<li className="navItem">
							<a href="#!" className="navLink"><span>Download</span></a>
						</li>
						<li className="navItem">
							<a href="#!" className="navLink"><span>Public Disclosure</span></a>
						</li> */}
					</ul>
				</nav>
				{/* Navigation End */}
			</div>
		</>
	)
}

export default Header
